import _ from 'lodash';

// <sh-neat-select>
//   possible attributes:
//     options="{valueField, labelField} in arrayExpression"
//     options="arrayOfStrings"
//     ng-model="chosenValue"
//     chosen="chosenObject"
//     unshift="''"
//     unshift="['','a']"
//     unshift="{id:0, name:'N/A'}"
//     unshift="[{id:null, name:''},{id:0, name:'N/A'}]"
//     push="'Other'"
//     push="['Yes','Really Yes']"
//     push="{id:0, name:'Other'}"
//     push="[{id:-1, name:'None of the Above'},{id:-2, name:'All of the Above'}]"

export default function neatSelectComponent($timeout) {
	'ngInject';
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: false,
		link: link,
		template: generateTemplate,
	};

	// functions only beyond this point
	function generateTemplate($elem, attrs) {
		'ngInject';
		attrs.nsScopeVar = _.uniqueId('neatSelectOptions');
		attrs.debug && console.log('in template() elem=', $elem, ' attrs=', attrs);

		var spec = parseOptions(attrs.options);
		var moreAttrs = '';
		angular.forEach(attrs, function (value, name) {
			// the following are attributes we want on sh-neat-select but not on select
			// except for ngModel which we manually copy over in case ng-model is not given
			if (
				_.isObject(value) ||
				['options', 'specify', 'unshift', 'push', 'ngModel', 'chosen', 'ngChange', 'debug'].indexOf(name) > -1
			) {
				return;
			}
			name = _.escape(_.kebabCase(name));
			value = _.escape(value);
			moreAttrs += ` ${name}="${value}"`;
		});
		let ngModel = _.escape(attrs.ngModel || _.uniqueId('neatSelectModel'));
		let valueField = _.escape(spec.valueField);
		let labelField = _.escape(spec.labelField);
		attrs.debug && console.log('ngModel', ngModel, attrs.ngModel, 'valueField', valueField, 'labelField', valueField);
		// use default option and ng-if="0" to disable angular's auto-select option
		var html = `
			<select ng-model="${ngModel}"${moreAttrs}>
			  <option
			    ng-repeat="item in ${attrs.nsScopeVar} track by item.${valueField}"
			    value="{{ item.${valueField} || '' }}"
			    ng-selected="item.${valueField} == ${attrs.ngModel}"
			    >{{ item.${labelField} }}</option>
			</select>`;
		attrs.debug && console.log('in template() html=', html);
		return html;
	}

	function parseOptions(options) {
		var match = options.match(/^\s*{\s*([\w_-]+)\s*,\s*([\w_-]+)\s*\}\s*in\s+(.+)\s*$/) || [];
		// match() will return null if we have `arrayOfStrings` format
		// and we will convert the array of strings to an array of objects
		// in the processOptions function which will use "value" and "label"
		var parsed = {
			itemType: match[1] ? 'object' : 'value',
			valueField: match[1] || 'value',
			labelField: match[2] || 'label',
			optionsExpr: match[3] || options,
		};
		return parsed;
	}

	function link($scope, $elem, attrs, model) {
		var spec = parseOptions(attrs.options);
		$scope.$watch(spec.optionsExpr, setFilteredOptions, true);
		if (attrs.chosen) {
			setupChosenChangeHandler();
			setupChosenWatch();
		} else if (attrs.ngChange) {
			setupValueChangeHandler();
		}

		// functions only beyond this point

		// update attrs.chosen when user chooses option
		function setupChosenChangeHandler() {
			let select = $elem.find('select');
			select.on('change', function (evt) {
				let chosenValue = select.val();
				let chosenObject = undefined;
				attrs.debug && console.log('onchange chosenValue', chosenValue);
				if (spec.itemType == 'value') {
					// set the scope variable based on the attribute (e.g. `chosen="vm.post.published_by"`)
					// _.set() handles the dot-delimited path such as `vm.post.published_by`
					_.set($scope, attrs.chosen, chosenValue);
				} else {
					// return the object that was chosen
					chosenObject = _.find($scope.$eval(spec.optionsExpr), obj => {
						return chosenValue == String(obj[spec.valueField]);
					});
					attrs.debug && console.log('chosenObject=', chosenObject);
					// set the scope variable based on the attribute (e.g. `chosen="vm.post.published_by"`)
					// _.set() handles the dot-delimited path such as `vm.post.published_by`
					_.set($scope, attrs.chosen, chosenObject);
				}
				if (attrs.ngChange) {
					evt.$value = chosenValue;
					evt.$object = undefined;
					$scope.$eval(attrs.ngChange, { $event: evt });
				}
				// run digest so scope will update
				$timeout(function () {}, 0);
			});
		}

		function setupValueChangeHandler() {
			let select = $elem.find('select');
			select.on('change', function (evt) {
				let chosenValue = select.val();
				attrs.debug && console.log('onchange chosenValue', chosenValue);
				if (attrs.ngChange) {
					evt.$value = chosenValue;
					evt.$object = undefined;
					$scope.$eval(attrs.ngChange, { $event: evt });
				}
				// run digest so scope will update
				$timeout(function () {}, 0);
			});
		}

		// set the select value based on a new attrs.chosen value
		function setupChosenWatch() {
			let select = $elem.find('select');
			$scope.$watch(attrs.chosen, setSelect);
			// use setTimeout since this component is initialized before scope is updated
			// and the watch won't fire until the next change
			setTimeout(function () {
				setSelect($scope.$eval(attrs.chosen));
			}, 0);

			// functions only here
			function setSelect(newVal, oldVal) {
				if (_.isUndefined(newVal)) {
					select.selectedIndex = -1;
				} else if (spec.itemType == 'object') {
					select.val(newVal[spec.valueField]);
				} else if (spec.itemType == 'value') {
					select.val(newVal);
				}
			}
		}

		// process the options array (array of objects or array of values)
		// and handle unshift and push attributes
		function processOptions(rawOptions) {
			attrs.debug && console.log('in processOptions() rawOptions=', rawOptions);
			// create a copy of the raw options so we can unshift and push as needed
			var allOptions = angular.copy(rawOptions);
			// handle shift and unshift
			var unshift = attrs.unshift ? $scope.$eval(attrs.unshift) : false;
			var push = attrs.push ? $scope.$eval(attrs.push) : false;
			if (angular.isArray(unshift)) {
				allOptions = unshift.concat(allOptions);
			}
			if (angular.isObject(unshift) || angular.isString(unshift)) {
				allOptions.unshift(unshift);
			}
			if (angular.isArray(push)) {
				allOptions = allOptions.concat(push);
			}
			if (angular.isObject(push) || angular.isString(push)) {
				allOptions.push(push);
			}
			// if we have array of arrays, convert to array of objects
			if (allOptions && allOptions.length && !angular.isObject(allOptions[0])) {
				allOptions = _.map(allOptions, function (value) {
					return {
						value: value,
						label: value,
					};
				});
			}
			attrs.debug && console.log('in processOptions() allOptions=', allOptions);
			attrs.debug &&
				console.log(
					'in processOptions() model.$modelValue=',
					model.$modelValue,
					'(type = ' + (angular.isNumber(model.$modelValue) ? 'number)' : 'string)')
				);
			// filter based on is_active
			var filtered = _.filter(allOptions, function (option) {
				if (String(model.$modelValue) == String(option[spec.valueField])) {
					// always include option if it is the currently chosen item
					return true;
				}
				return typeof option.is_active == 'undefined' || !!String(option.is_active).match(/^(true|1)$/);
			});
			attrs.debug && console.log('in processOptions() filtered=', filtered);
			return filtered;
		}

		// set the filtered options
		function setFilteredOptions(newValue, oldValue) {
			attrs.debug && console.log('in render() id=' + attrs.nsScopeVar + ' and spec.optionsExpr=', spec.optionsExpr);
			attrs.debug &&
				console.log('in render() id=' + attrs.nsScopeVar + ' and $scope value=', $scope.$eval(spec.optionsExpr));
			var filtered = processOptions($scope.$eval(spec.optionsExpr));
			if (JSON.stringify(filtered) != JSON.stringify($scope[attrs.nsScopeVar])) {
				// only update if options actually changed
				// now reset the chosen and ngModel if options are changed later
				if ($scope[attrs.nsScopeVar] && attrs.ngModel) {
					_.set($scope, attrs.ngModel, undefined);
				}
				if ($scope[attrs.nsScopeVar] && attrs.chosen) {
					_.set($scope, attrs.chosen, undefined);
				}
				attrs.debug && console.log('filtered options actually changed');
				$scope[attrs.nsScopeVar] = processOptions($scope.$eval(spec.optionsExpr));
			} else {
				attrs.debug && console.log('filtered options did not change');
			}
		}
	}
}
